import type { SVGProps } from 'react';

const SvgTransactionFile = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4.22876 4.22924L4.22876 5.5586L9.49435 5.56332L3.75736 11.3003L4.70017 12.2431L10.4372 6.50613L10.4324 11.7717H11.7712V4.22924H4.22876Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgTransactionFile;
